export const RECEIPT_CREATED = "RECEIPT_CREATED";
export const RECEIPT_UPDATED = "RECEIPT_UPDATED";
export const RECEIPT_UPDATED_CONTENT = "RECEIPT_UPDATED_CONTENT";
export const RECEIPT_APPROVED = "RECEIPT_APPROVED";
export const RECEIPT_SENT_BACK = "RECEIPT_SENT_BACK";
export const RECEIPT_REMOVED = "RECEIPT_REMOVED";
export const RECEIPT_SNOOZED = "RECEIPT_SNOOZED";
export const RECEIPT_DRAFT_SEND_IN = "RECEIPT_DRAFT_SEND_IN";
export const RECEIPT_DRAFT_REMOVED = "RECEIPT_DRAFT_REMOVED";
export const RECEIPT_DRAFT_UPDATED = "RECEIPT_DRAFT_UPDATED";
export const RECEIPT_CREATED_FROM_CLASSIFICATION = "RECEIPT_CREATED_FROM_CLASSIFICATION";
export const DELETE_CLASSIFIED_RECEIPT = "DELETE_CLASSIFIED_RECEIPT";
export const CONVERT_CLASSIFIED_RECEIPT = "CONVERT_CLASSIFIED_RECEIPT";
